export const checkIsProductGiftCard = articleNumber => {
  return /^01\d{4}-00-00000$/.test(articleNumber);
};
